export default __webpack_public_path__ + "static/media/scroll.3ccde61a.svg";